import { Directive, ElementRef, HostListener } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { FullScreenMediaComponent } from '../modals/full-screen-media/full-screen-media.component';

@Directive({
  selector: '[watchFullscreen]'
})
export class FullscreenWatcherDirective {

  constructor(
    private el: ElementRef,
    private modalCtrl: ModalController,
  ) { }

  @HostListener('webkitfullscreenchange', ['$event'])
  @HostListener('mozfullscreenchange', ['$event'])
  @HostListener('fullscreenchange', ['$event'])
  async onFullscreenChange(event: Event) {
    const isFullscreen = !!(document.fullscreenElement || (document as any).webkitFullscreenElement || (document as any).mozFullScreenElement);
    if (!isFullscreen) {
      return;
    }
    if (event.target !== this.el.nativeElement) {
      return;
    }
    const source = this.el.nativeElement.getElementsByTagName('source')[0] as HTMLSourceElement | undefined;
    const url = source?.src;
    if (!url) {
      return;
    }
    const video = this.el.nativeElement as HTMLVideoElement;
    if (!video.paused) {
      video.pause();
    }

    try {
      await (document.exitFullscreen?.() ?? (document as any).webkitExitFullscreen?.() ?? Promise.resolve());
    } catch {
      /* ignore */
    }
    const modal = await this.modalCtrl.create({
      backdropDismiss: false,
      component: FullScreenMediaComponent,
      cssClass: 'fullScreenMediaModal',
      componentProps: {
        images: [{ image: url, title: '' }],
        type: 'video',
        index: 0,
      },
    });
    await modal.present();
  }
}